import React from "react";
import { Routes, Route } from "react-router-dom";
import UsersList from "pages/users/UsersList";
import UserDetails from "pages/users/UserDetails";

const UsersRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<UsersList />} />
      <Route path=":userId" element={<UserDetails />} />
    </Routes>
  );
};

export default UsersRoutes;
